export default __webpack_public_path__ + "static/media/Nihilistic Robe.80ca9149.jpg";